import { coreApi } from "./coreApi";

const financialAnalysisApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getFinancialAnalysis: builder.query({
      query: (query) => `/accounting/reports/financial-analysis?${query}`,
    }),
  }),
});

export const { useGetFinancialAnalysisQuery, useLazyGetFinancialAnalysisQuery } =
  financialAnalysisApi;

export default financialAnalysisApi;
